<div class="report-frame">
  <div class="positionCenter" style="display: flex;">
    <mat-progress-spinner [color]="color" [mode]="mode" [value]="value" diameter="40">
    </mat-progress-spinner><span class="loadingText">{{loadingText}}</span>
  </div>

</div>
